import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { Button } from '@/components/Buttons';
import { useBeforeunload } from 'react-beforeunload';
// import theme from './RouterPrompt.module.scss';
import { Trans } from '@lingui/react/macro';
interface RouterPromptProps {
    when?: boolean;
}
// This is based on https://medium.com/nerd-for-tech/custom-react-router-prompt-d325538b4d2b

/**
 * Add this component to a place where you don't want the user to accidentally leave the page without saving.
 */
const RouterPrompt: React.FC<RouterPromptProps> = ({ when = true }) => {
    const history = useHistory();

    const [showPrompt, setShowPrompt] = useState(false);
    const [currentPath, setCurrentPath] = useState('');

    useBeforeunload((event) => {
        if (when) {
            event.preventDefault();
        }
    });

    useEffect(() => {
        if (when) {
            history.block((prompt) => {
                setCurrentPath(prompt.pathname);
                setShowPrompt(true);
                return 'true';
            });
        } else {
            history.block(() => {});
        }

        return () => {
            history.block(() => {});
        };
    }, [history, when]);

    const handleOK = useCallback(async () => {
        history.block(() => {});
        history.push(currentPath);
    }, [currentPath, history]);

    const handleCancel = useCallback(async () => {
        setShowPrompt(false);
    }, []);

    return showPrompt ? (
        <Modal isOpen={showPrompt}>
            <ModalHeader>
                <Trans>Are you sure?</Trans>
            </ModalHeader>
            <ModalBody>
                <Trans>There are unsaved changes. Are you sure want to leave this page?</Trans>
            </ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={handleCancel}>
                    <Trans>Cancel</Trans>
                </Button>
                <Button color="danger" onClick={handleOK}>
                    <Trans>Yes</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    ) : null;
};
export default RouterPrompt;
